import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Space, Typography, Col, Row, Layout, Spin } from "antd";
import { CaretRightFilled } from "@ant-design/icons";
import MainHeader, { MENU_ADMIN } from "../components/common/MainHeader";
import SyncDataModal from "../components/admin/SyncDataModal";
import {
  URL_AUTH,
  URL_AX_DB,
  URL_LOG_WOOD,
  URL_SCALE_LARGE,
  URL_SYNC_DATA,
} from "../constance/urls";
import Cookies from "js-cookie";
import { useHistory } from "react-router-dom";
import { PATH } from "../routes/Routes";
import { GET } from "../utils/HttpClient";
import * as _ from "lodash";
import UpdateDataModal from "../components/admin/UpdateDataModal";
import { SYNC_TYPE } from "../constance/dataTypes/sync_data";
import { useUserContext } from "../hooks/UserSettingProvider";
import { BLUE_COLOR } from "../constance/color";
import ColorButton from "../components/common/ColorButton";

export default function AdminView() {
  const { t } = useTranslation();
  const { onLogout } = useUserContext();
  const [activeMenu, setActiveMenu] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const history = useHistory();

  const syncUrl = {
    log_wood_evaluation_data_sync: URL_LOG_WOOD.LOG_WOOD_EVALUATION_DATA_SYNC,
    truck_transaction_sync: URL_SCALE_LARGE.TRUCK_TRANSACTION_SYNC,
  };

  const updateUrl = {
    update_ax_code_from_wwg_wage: {
      syncUrl: URL_SYNC_DATA.SYNC_AX_CODE,
      syncType: SYNC_TYPE.WWG_WAGE,
    },
    update_employee_from_outpay: {
      syncUrl: URL_SYNC_DATA.SYNC_EMPLOYEE,
      syncType: SYNC_TYPE.EMPLOYEE,
    },
  };

  const adminMenu = [
    // sync data from grail server
    {
      id: "log_wood_evaluation_data_sync",
      name: t("admins.log_wood_evaluation_data_sync.title"),
      onClick: () => setActiveMenu("log_wood_evaluation_data_sync"),
    },
    {
      id: "truck_transaction_sync",
      name: t("admins.truck_transaction_sync.title"),
      onClick: () => setActiveMenu("truck_transaction_sync"),
    },

    // sync data from ms ax db and will send to update grail server
    {
      id: "update_ax_code_from_wwg_wage",
      name: t("admins.update_ax_code_from_wwg_wage.title"),
      onClick: () => setActiveMenu("update_ax_code_from_wwg_wage"),
    },
    {
      id: "update_employee_from_outpay",
      name: t("admins.update_employee_from_outpay.title"),
      onClick: () => setActiveMenu("update_employee_from_outpay"),
    },

    {
      id: "admin_django_page",
      name: t("admins.admin_django_page"),
      onClick: () => window.open("/api/admin"),
    },
  ];

  const logOut = () => {
    onLogout();
    history.replace(PATH.LOGIN);
  };

  React.useEffect(() => {
    const isAdmin = async () => {
      try {
        const response = await GET(URL_AUTH.IS_ADMIN);
        if (!response.data.is_admin) {
          logOut();
        }
        setIsLoading(false);
      } catch {
        logOut();
      }
    };
    isAdmin();
  }, []);
  return (
    <div>
      {isLoading && <Spin tip="Loading" size="large" />}
      <MainHeader activeItem={MENU_ADMIN} />

      <Layout style={{ marginTop: "7em" }}>
        <Typography.Title level={2}>{t("menus.admin")}</Typography.Title>

        <div>
          {adminMenu.map((menu) => (
            <Row key={menu.id}>
              <Col
                xs={{ offset: 2, span: 24 }}
                sm={{ offset: 7, span: 12 }}
                lg={{ offset: 9, span: 8 }}
                md={{ offset: 7, span: 13 }}
              >
                <br />
                <ColorButton
                  onClick={menu.onClick}
                  variant="outlined"
                  color="primary"
                  override={BLUE_COLOR}
                  icon={<CaretRightFilled />}
                  style={{
                    width: "80%",
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  <Space
                    style={{
                      flex: 1,
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {menu.name}
                  </Space>
                </ColorButton>
              </Col>
            </Row>
          ))}
        </div>
        {/* menu modal */}
        <SyncDataModal
          url={_.get(syncUrl, activeMenu, "")}
          title={activeMenu ? t(`admins.${activeMenu}.title`) : ""}
          content={activeMenu ? t(`admins.${activeMenu}.content`) : ""}
          open={activeMenu && activeMenu.includes("sync")}
          onClose={() => setActiveMenu(null)}
        />

        <UpdateDataModal
          syncUrl={_.get(updateUrl, `${activeMenu}.syncUrl`, "")}
          syncType={_.get(updateUrl, `${activeMenu}.syncType`, "")}
          activeMenu={activeMenu}
          open={activeMenu && activeMenu.includes("update")}
          onClose={() => setActiveMenu(null)}
        />
      </Layout>
    </div>
  );
}
